import https from "../utils/http";

// Issues a new token pair under one of the account's other roles. Returns the
// same Data shape as login (Roles, ActiveRole, Token, RefreshToken, expiries),
// so the caller can hand the payload straight to AuthService.setSession().
//
// Fails with 400 + errors[0].code === "validation" when the account doesn't hold
// the requested role, and 404 when the user no longer exists.
export const switchRole = async (role) => {
   const response = await https.post("/Accounts/switch-role", { role });
   return response.data;
};
